export default __webpack_public_path__ + "static/media/DiverseTalent.06f16ce1.png";